




























  import { Component, Vue, Watch, Prop } from "vue-property-decorator";
  import { store, StoreState } from "../store";
  import { mapState } from "vuex";
  //import AES from 'crypto-js/aes';
  //import CryptoJS from 'crypto-js';
 // import { watch } from "fs";


  @Component({
    components: {
    },
    computed: {
    },
    mounted: function () {
      if(this.$props.parentsData)
      {
        this.$data.index = this.$props.parentsData.index;
        this.$data.data = this.$props.parentsData.data;
        this.$data.value = this.$props.parentsData.value;
        this.$data.placeholder = (this.$props.parentsData.placeholder) ? this.$props.parentsData.placeholder : '';
        this.$data.id = (this.$props.parentsData.index > -1)?this.$props.parentsData.index+this.$props.parentsData.type:this.$data.rand;
        this.$data.class1 = (this.$props.parentsData.class && this.$props.parentsData.class.class1)?this.$props.parentsData.class.class1:"";
        this.$data.class2 = (this.$props.parentsData.class && this.$props.parentsData.class.class2)?this.$props.parentsData.class.class2:"";
        this.$data.class3 = (this.$props.parentsData.class && this.$props.parentsData.class.class3)?this.$props.parentsData.class.class3:"";
        this.$data.class4 = (this.$props.parentsData.class && this.$props.parentsData.class.class4)?this.$props.parentsData.class.class4:"";
        this.$data.class5 = (this.$props.parentsData.class && this.$props.parentsData.class.class5)?this.$props.parentsData.class.class5:"";
        this.$data.hr_brk = (this.$props.parentsData.break_hr)?parseInt(this.$props.parentsData.break_hr):this.$data.hr_brk;
        this.$data.is_disable = this.$props.parentsData.isDisable;
        this.$data.is_disable = (this.$data.is_disable) ? this.$data.is_disable : false;
        this.$data.is_error = this.$props.parentsData.isError;
        this.$data.is_error = (this.$data.is_error) ? this.$data.is_error : false;
        this.removeAllClass();
        
        
      }
    },
  updated: function() {
      this.removeAllClass();
    
  }

  })
  export default class CustomSelect extends Vue {
    data() {
      return {
        focus: false,
        is_loading: false,
        isDisplayed: false,
        open: [false],
        selectedVal: "",
        menu: [],
        currentDataIndex: -1,
        index: 0,
        flag: 0,
        sub_prp:[],
        data: [],
        value: "",
        id: "",
        class1: "",
        class2: "",
        class3: "",
        class4: "",
        class5: "",
        hr_brk: 0,
        is_disable: false,
        is_error: false,
        rand: Math.random().toString(36).slice(2),
        placeholder: '',
        cssHoverId: '',
        eventListnerHandleFlag: 0,
        currentKey: '',
        setInterValHandle: '',
        keyPressCount: 0
      };


    }

    @Prop()
    public parentsData!: any;

    @Watch('parentsData')
        onChange() {
            if(this.$props.parentsData)
            {
              this.$data.index = this.$props.parentsData.index;
              this.$data.data = this.$props.parentsData.data;
              this.$data.value = this.$props.parentsData.value;
              this.$data.placeholder = (this.$props.parentsData.placeholder) ? this.$props.parentsData.placeholder : '';
              this.$data.id = (this.$data.id)?this.$data.id:(this.$props.parentsData.index > -1)?this.$props.parentsData.index+this.$props.parentsData.type:this.$data.rand;
              this.$data.class1 = (this.$props.parentsData.class && this.$props.parentsData.class.class1)?this.$props.parentsData.class.class1:"";
              this.$data.class2 = (this.$props.parentsData.class && this.$props.parentsData.class.class2)?this.$props.parentsData.class.class2:"";
              this.$data.class3 = (this.$props.parentsData.class && this.$props.parentsData.class.class3)?this.$props.parentsData.class.class3:"";
              this.$data.class4 = (this.$props.parentsData.class && this.$props.parentsData.class.class4)?this.$props.parentsData.class.class4:"";
              this.$data.class5 = (this.$props.parentsData.class && this.$props.parentsData.class.class5)?this.$props.parentsData.class.class5:"";
              this.$data.hr_brk = (this.$props.parentsData.break_hr)?parseInt(this.$props.parentsData.break_hr):this.$data.hr_brk;
              this.$data.is_disable = this.$props.parentsData.isDisable;
              this.$data.is_disable = (this.$data.is_disable) ? this.$data.is_disable : false;
              this.$data.is_error = this.$props.parentsData.isError;
              this.$data.is_error = (this.$data.is_error) ? this.$data.is_error : false;
                  this.removeAllClass();

              

            }
		}
    

    callingParentComponentMethod(index, value) {  
      // emit the event and call the parent component  
      this.$emit("setParentComponentDetails", {value: value, index: index, incoming: this.$props.parentsData});  
      // console.log(data);
      }
      disableScroll() {
        if((document.querySelector(".propt_modal_back") as any))
          (document.querySelector(".propt_modal_back") as any).style.overflow = 'hidden';
           if((document.querySelector(".companysettings") as any))
          (document.querySelector(".companysettings") as any).style.position = 'fixed';
        // Get the current page scroll position 
        // let scrollTop = Vue.prototype.pageYOffset || document.documentElement.scrollTop; 
        // let scrollLeft = Vue.prototype.pageXOffset || document.documentElement.scrollLeft;
      
        //     // if any scroll is attempted, set this to the previous value 
        //     window.onscroll = function() { 
        //         window.scrollTo(scrollLeft, scrollTop); 
        //     }; 
    } 
  
    enableScroll() { 
      if((document.querySelector(".propt_modal_back") as any))
        (document.querySelector(".propt_modal_back") as any).style.overflow = '';
      if((document.querySelector(".companysettings") as any))
          (document.querySelector(".companysettings") as any).style.position = 'absolute';
    }
    mousehandle(type, id)
    {
      switch(type)
      {
        case "over":
          var elems = document.querySelectorAll(".hover-class");

            [].forEach.call(elems, function(el) {
                el.className = el.className.replace(/\hover-class\b/, "");
            });
            var elm = document.getElementById(id);
            elm.classList.add("hover-class")
          break;
        case "out":
          this.$data.cssHoverId = id;
          var elm = document.getElementById(id);
          elm.classList.remove("hover-class")
          break;
      }
    }
    old_index = 0
    setData(type, key)
    {
      if(type)
      {
        // console.log("oldindex - "+this.$data.currentDataIndex);
        this.old_index++;
        let currentDataIndex = this.$data.currentDataIndex;
        let flag = this.$data.flag;
        // console.log("currentDataIndex - "+currentDataIndex);
        // console.log("key - "+key);
        // console.log("flag - "+flag);
        // if(flag>1)
        // {
        //   if(key == "ArrowDown")
        //   {
        //     currentDataIndex = currentDataIndex - flag;
        //     if(currentDataIndex >= this.$data.data.length-1)
        //       currentDataIndex = this.$data.data.length -1;
        //     if(currentDataIndex <= 0)
        //       currentDataIndex = 0;
            
        //   }
        //   else if(key == "ArrowUp")
        //   {
        //     currentDataIndex = currentDataIndex + flag;
        //     if(currentDataIndex <= 0)
        //       currentDataIndex = 0;
        //     if(currentDataIndex >= this.$data.data.length-1)
        //       currentDataIndex = this.$data.data.length -1;
        //   }
        // }
        // console.log("modified currentDataIndex - "+currentDataIndex);
        this.$data.value = this.$data.data[currentDataIndex];
        let elm_id = this.$data.id+'_dd_val_'+currentDataIndex;
        this.mousehandle("over", elm_id);
        //this.callingParentComponentMethod(currentDataIndex, this.$data.data[currentDataIndex]);
        this.$emit("setParentComponentDetails", {value: this.$data.data[currentDataIndex], index: currentDataIndex, incoming: this.$props.parentsData});  
        return false;
      }
    }
    eventListnerHandle()
    {
      this.$data.eventListnerHandleFlag = 1;
      document.getElementById(this.$data.id+'_customdd0')
          .addEventListener('keyup', function (e) {
          this.$data.currentKey = e.key;
          this.$data.keyPressCount = this.$data.keyPressCount + 1;
        }.bind(this));
    }
      check_focus(type)
      {
        if(!type) this.enableScroll();
        this.$data.focus = type;
        
        if(type) //i
        {
          this.$data.flag++;
          this.disableScroll();
          if(this.$data.eventListnerHandleFlag == 0)
            this.eventListnerHandle()
          let oldKey = '';
          let keyPressCount = 0;
          this.$data.setInterValHandle = setInterval(function()
          {
            let currentIndex = this.$data.currentDataIndex;
            if( keyPressCount != this.$data.keyPressCount) //oldKey != this.$data.currentKey &&
            {
              if(this.$data.currentKey == "ArrowDown")
              {
                if(!document.querySelector('.show-drop-down'))
                {
                  setTimeout(function(){
                    let element2: any = document.getElementById(this.$data.id+"_customdd");
                    element2.classList.add("show-drop-down");
                  }.bind(this), 100);
                  
                  this.$data.currentDataIndex = -1;
                }
                if(this.$data.currentDataIndex+1 == this.$data.data.length)
                  this.$data.currentDataIndex = this.$data.data.length - 1;
                else
                  this.$data.currentDataIndex = this.$data.currentDataIndex + 1;
                
                if(this.$data.data[this.$data.currentDataIndex])
                {
                  this.setData(type, this.$data.currentKey);
                }
                keyPressCount = this.$data.keyPressCount;
                // this.$data.currentDataIndex = -1;
                return false;
              }
              if(this.$data.currentKey == "ArrowUp")
              {
                if(this.$data.currentDataIndex - 1 == -1 || this.$data.currentDataIndex < 0)
                  this.$data.currentDataIndex = 0;
                else
                  this.$data.currentDataIndex = this.$data.currentDataIndex - 1;
                if(this.$data.data[this.$data.currentDataIndex] && currentIndex != this.$data.currentDataIndex)
                {
                  this.setData(type, this.$data.currentKey);   
                }
                keyPressCount = this.$data.keyPressCount;
                // this.$data.currentDataIndex = -1;
                return false;
              }
              if(this.$data.currentKey == "Enter" || this.$data.currentKey == "Escape") //
              {
                let element2: any = document.getElementById(this.$data.id+"_customdd");
                if(!document.querySelector('.show-drop-down'))
                {
                  setTimeout(function(){
                    element2.classList.add("show-drop-down");
                  }.bind(this), 100);
                }
                else
                {
                  setTimeout(function(){
                    element2.classList.remove("show-drop-down");
                    // this.$data.currentDataIndex = -1;
                  }.bind(this), 100);
                }
              }
              //key function end here
            }
            oldKey = this.$data.currentKey;
            keyPressCount = this.$data.keyPressCount;
          }.bind(this),100);
          /*
if(type)
          {
            // console.log(e.key);
            let old_curr = this.$data.currentDataIndex;
            if(e.key == "ArrowDown")
            {
              if(!document.querySelector('.show-drop-down'))
              {
                setTimeout(function(){
                  let element2: any = document.getElementById(this.$data.id+"_customdd");
                  element2.classList.add("show-drop-down");
                }.bind(this), 100);
                
                this.$data.currentDataIndex = -1;
              }
              if(this.$data.currentDataIndex+1 == this.$data.data.length)
                this.$data.currentDataIndex = this.$data.data.length - 1;
              else
                this.$data.currentDataIndex = this.$data.currentDataIndex + 1;
              
              if(this.$data.data[this.$data.currentDataIndex])
              {
                this.setData(type, e.key);
              }
              return false;
            }
            if(e.key == "ArrowUp")
            {
              if(this.$data.currentDataIndex - 1 == -1 || this.$data.currentDataIndex < 0)
                this.$data.currentDataIndex = 0;
              else
                this.$data.currentDataIndex = this.$data.currentDataIndex - 1;
              if(this.$data.data[this.$data.currentDataIndex])
              {
                this.setData(type, e.key);   
              }
              return false;
            }
            if(e.key == "Enter" || e.key == "Escape") //
            {
              let element2: any = document.getElementById(this.$data.id+"_customdd");
              if(!document.querySelector('.show-drop-down'))
              {
                setTimeout(function(){
                  element2.classList.add("show-drop-down");
                }.bind(this), 100);
              }
              else
              {
                setTimeout(function(){
                  element2.classList.remove("show-drop-down");
                  this.$data.currentDataIndex = -1;
                }.bind(this), 100);
              }
              return false;
            }
          }
          */
          
        }
        else
        {
          if(document.querySelector('.show-drop-down'))
          {
            setTimeout(function(){
              document.querySelector('.show-drop-down').
              classList.remove("show-drop-down");
              // this.$data.currentDataIndex = -1;
            }.bind(this), 100);
          }
          this.$data.currentDataIndex = -1;
          if(this.$data.setInterValHandle)
            clearInterval(this.$data.setInterValHandle);
        }
      }
      keycontrol(type, index)
    {
      // console.log(type);
      // console.log(index);
    }
    removeClassesbyElememt(e)
    {
      // let existingClassArr = e.classList.value.split(" ");
      // // console.log("Class - " + existingClassArr[i]);
      // for(let i = 0; i < existingClassArr.length; i++)
      // {
      //   if(existingClassArr[i])
      //     e.classList.remove(existingClassArr[i]);
      // }
      return true;
    }
    removeAllClass()
    {
      if(this.$data.class1 && document.getElementById(this.$data.id+"_customdd0"))
      {
        let element: any = document.getElementById(this.$data.id+"_customdd0");
        if(this.removeClassesbyElememt(element))
        {
          element.classList.add('dropdown');
          element.classList.add(this.$data.class1);
        }
      }
      if(this.$data.class2 && document.getElementById(this.$data.id+"_customdd1"))
      {
        let element: any = document.getElementById(this.$data.id+"_customdd1");
        if(this.removeClassesbyElememt(element))
        {
          element.classList.add('notifydropdown');
          element.classList.add(this.$data.class2);
        }
      }
      if(this.$data.class3 && document.getElementById(this.$data.id+"_customdd2"))
      {
        let element: any = document.getElementById(this.$data.id+"_customdd2");
        if(this.removeClassesbyElememt(element))
          element.classList.add(this.$data.class3);
      }
      if(this.$data.class4 && document.getElementById(this.$data.id+"_customdd"))
      {
        let element: any = document.getElementById(this.$data.id+"_customdd");
        if(this.removeClassesbyElememt(element))
        {
          element.classList.add('dropdown-class');
          element.classList.add(this.$data.class4);
        }
      }
      if(this.$data.class5 && document.getElementById(this.$data.id+"_customdd3"))
      {
        let element: any = document.getElementById(this.$data.id+"_customdd3");
        if(this.removeClassesbyElememt(element))
        {
          element.classList.add('dropoption');
          element.classList.add(this.$data.class5);
        }
      }
    }

    handlecustomdd(type, index)
    {
      // console.log("custom dd");
      this.$emit("setParentComponentDetails", {click: true});  
      // if(document.querySelector(".dropdown-class"))
      if(document.querySelector(".show-drop-down"))
      {
        let element: any = document.querySelector(".show-drop-down");
        element.classList.remove("show-drop-down");
      }
      // console.log("click");
      switch(type)
      {
        case "close":
          // if(index == 0 && this.$data.last_dd_id)
          // {
          //   let prev_index = this.$data.last_dd_id;
          //   let element2: any = document.getElementById(prev_index+"_customdd");
          //   element2.classList.remove("show-drop-down");
          // }
          break;
        case "toggle":
          // this.$data.last_dd_id _customdd

          // console.log(index);
          // console.log(this.$data.last_dd_id);

          setTimeout(function(){
            // if(this.$data.last_dd_id && this.$data.last_dd_id != index)
            // {
            //   // console.log(index);
            //   // console.log(this.$data.last_dd_id);
            //   let prev_index = this.$data.last_dd_id;
            //   let element2: any = document.getElementById(prev_index+"_customdd");
            //   element2.classList.remove("show-drop-down");
            // }
            // console.log(this.$data.open[index]);
            if(this.$data.open[index])
            {
              let element2: any = document.getElementById(index+"_customdd");
              if(document.querySelector(".show-drop-down"))
                element2.classList.remove("show-drop-down");
            }
            else
            {
              let element2: any = document.getElementById(index+"_customdd");
              if(element2)
                element2.classList.add("show-drop-down");
            }
            
            // console.log(this.$data.open);
            // console.log(index);
            // this.$data.open[index] = !this.$data.open[index];
            this.$data.open[index] = !this.$data.open[index];
            this.$data.last_dd_id = index;
          }.bind(this), 110)
          // console.log(this.$data.open);
          break;
        default:
          break;
      }
    }
  }

